import api from '@services/api'

export const getAllLogs = (
    page,
    pageSize,
    orderBy,
    search,
    filters,
    fromDate,
    toDate,
    userType
) => {
    return (dispatch, getState) => {
        api.getAllLogs(
            page,
            pageSize,
            orderBy,
            search,
            filters,
            fromDate,
            toDate,
            userType
        ).subscribe(
            (res) => {
                console.log('getAllLogs res', res)

                dispatch(setLogs(res.data))
            },
            (error) => {
                console.log('getAllLogs error', error)
                Promise.resolve()
            }
        )
    }
}

export const setLogs = (logs) => ({
    type: 'SET_LOGS',
    logs,
})
